import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9af7174a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "content_square_nav" }
const _hoisted_3 = { class: "content_square_nav_icon" }
const _hoisted_4 = { class: "content_square_nav_right" }
const _hoisted_5 = { class: "square_nav_right_title" }
const _hoisted_6 = { class: "square_nav_right_txt" }

import { computed, reactive } from 'vue';
import { useHomeStore } from '@/pinia/home';

interface IData {
  id: number;
  title: string;
  icon: string;
  text: string;
  textIcon?: string;
  toUrl: string;
  // 对应的权限Name 对应routeName
  roleName: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const homeStore = useHomeStore();

const navigationList = reactive<IData[]>([
  {
    id: 0,
    title: '云导播',
    icon: 'navigation_guide',
    text: '输入源支持直播流，自定义布局，支持文字、图片等素材。',
    textIcon: 'navigation_hot',
    toUrl: '/application/guide',
    roleName: 'CloudGuide',
  },
  // {
  //   id: 1,
  //   title: '云拆条',
  //   icon: 'navigation_striping',
  //   text: '支持在第一时间对直播视频进行剪辑并生成视频进行分发。',
  //   toUrl: '/application/striping',
  //   roleName: 'CloudStriping',
  // },
  {
    id: 3,
    title: '签到上墙',
    icon: 'navigation_sign',
    text: '签到墙可展示多种炫酷效果,带来最燃 最火爆的活动开场!',
    toUrl: '/application/signWall',
    roleName: 'SignWall',
  },
  {
    id: 4,
    title: '集五福',
    icon: 'navigation_fiveluckey',
    text: '集福袋模板一键免费拥有,1分钟即可生成活动',
    toUrl: '/application/five_lucky',
    roleName: 'FiveLuckyGame',
  },
]);
// 有权限的列表过滤
const navAutoList = computed(() => navigationList.filter((item) => homeStore.funcData[item.roleName]));

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navAutoList), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "content_square",
        key: item.id
      }, [
        _createVNode(_component_router_link, {
          to: item.toUrl
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_svg_icon, {
                  "icon-class": item.icon
                }, null, 8, ["icon-class"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(item.title) + " ", 1),
                  (item.textIcon)
                    ? (_openBlock(), _createBlock(_component_svg_icon, {
                        key: 0,
                        "icon-class": item.textIcon,
                        class: "right_title_icon"
                      }, null, 8, ["icon-class"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.text), 1)
              ])
            ])
          ]),
          _: 2
        }, 1032, ["to"])
      ]))
    }), 128))
  ]))
}
}

})